import { InjectionToken } from '@angular/core';

export const MOCK_SELECTORS = new InjectionToken('@ngrx/store Mock Selectors');
